module.exports = __webpack_public_path__ + "media/applicants/awaiting_approval-a3bcf5f5.jpg";